import woltInstance from '../instance'

const deleteDriverIntegrations = (id) => {
  return woltInstance.delete(`/driverIntegrations/${id}`)
}

export default deleteDriverIntegrations
